import React, {useEffect, useState} from "react";
import P from "../lib/P";
import {ActivityIndicator} from "react-native";
import MainStyle from "../../MainStyle";
import Button from "./Button";
import Div from "../lib/Div";
import moment from "moment";
import AsyncStorage from "@react-native-async-storage/async-storage";

const STORAGE_KEY = 'kyc_restart_block_started_at';

type Props = { kycStatus: number, restartKyc: () => void };

const LoadingKYC = (props: Props) => {
  const {kycStatus} = props;
  const [datePoint, setDatePoint] = useState('');
  const [, setTimer] = useState(0);
  const disableRestartKyc = !!datePoint && moment(datePoint).isAfter(moment());

  useEffect(() => {
    if (kycStatus === 3) {
      (async () => {
        const endedAt = await AsyncStorage.getItem(STORAGE_KEY);

        if (!endedAt || (endedAt && moment(endedAt).isBefore(moment()))) {
          const time = moment().add(1, 'minutes').format();
          AsyncStorage.setItem(STORAGE_KEY, time).catch(err => console.log('err', err));
          setDatePoint(time);

        } else {
          setDatePoint(endedAt);
        }
      })();

    } else {
      AsyncStorage.setItem(STORAGE_KEY, '').catch(err => console.log('err', err));
      setDatePoint('');
    }
  }, [kycStatus]);

  useEffect(() => {
    const time = setInterval(() => {
      setTimer(prev => prev + 1);
    }, 1000);

    return () => {
      clearInterval(time);
    };
  }, []);

  return (
    <Div flex={1} justifyContent="center" alignItems="center">
      <P fw="500" mb={22}>
        {kycStatus === 3 ? 'KYC verification started' : kycStatus === 4 ? `Waiting for KYC confirmation\nThis may take several minutes` : ''}
      </P>

      <ActivityIndicator color="white" size={30} style={MainStyle.m_b_20}/>

      {kycStatus === 3 && (
        <Button
          w={244} h={24} mb={19} fontSize={16}
          text={`Restart KYC Verification ${disableRestartKyc ? `(${moment(datePoint).diff(moment(), 'seconds')})` : ''}`}
          onPress={props.restartKyc} mx="auto" disabled={disableRestartKyc}
        />
      )}
    </Div>
  );
};

export default React.memo(LoadingKYC);
